import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
export const conciergeRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "AI agents", breadcrumbNavigate: false },
    children: [
      {
        index: true,
        async lazy() {
          const { ConciergeAiConversationsRedirect } =
            await import("./concierge-ai-conversations-redirect");
          return { Component: ConciergeAiConversationsRedirect };
        },
      },
      ...["conversations", "monitoring", "testing"].map((path) => ({
        path,
        async lazy() {
          const { ConciergeAiConversationsRedirect } =
            await import("./concierge-ai-conversations-redirect");
          return { Component: ConciergeAiConversationsRedirect };
        },
      })),
      {
        path: "knowledge",
        handle: { breadcrumb: "Knowledge" },
        async lazy() {
          const { AgentKnowledgePage } =
            // redont-allow-dynamic-import: route-level code splitting
            await import("@redotech/redo-merchant-agent-knowledge-app/page");
          return { Component: AgentKnowledgePage };
        },
      },
      {
        path: "about",
        async lazy() {
          const { AboutConcierge } = await import("./about");
          return { Component: AboutConcierge };
        },
      },
      {
        path: "onboard",
        async lazy() {
          const { SelfServePage } =
            await import("./self-serve/self-serve-page");
          return { Component: SelfServePage };
        },
      },
      {
        path: "preview",
        async lazy() {
          const { PreviewPage } = await import("./preview/preview-page");
          return { Component: PreviewPage };
        },
      },
    ],
  },
];
